import React, { useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import Step02SVG  from "itd-common/assets/images/onboarding/tutorial_step_02.png";
import Step03SVG  from "itd-common/assets/images/onboarding/tutorial_step_03.png";
import "./authAside.scss"
import Icon from '../../controls/icon/icon';

const T_PREFIX: string = 'pages.authAside.qrScan.';

const QrScan: React.FC = () => {
    const { t } = useTranslation();
    const [isStep1, setIsStep1] = useState<boolean>(true);

    return (
        <div className="platform-section" style={{ maxWidth: `23rem`  }}>
            <div className="row">
                <div className="col-md-12">
                    <h1 className="platform-title">
                        <span>{t(`${T_PREFIX}title1`)}</span> {t(`${T_PREFIX}title2`)}
                    </h1>
                </div>
                {   isStep1 ?
                    <div className="row wrap_content">
                        <div className="col-md-6">
                            <div className="platform-step my-2">
                                <div className='d-inline-block'>
                                    <span className="fs-7 fw-bold mb-1">{t(`${T_PREFIX}step1`)}</span>
                                    <h3 className='fs-6 fw-bold'>{t(`${T_PREFIX}howReadQr`)}</h3>
                                    {/* <p>{t(`${T_PREFIX}default.section.description`)}</p> */}
                                </div>
                            </div>
                            <div className="platform-step mb-2">
                                <small className="fs-7">{t(`${T_PREFIX}scanQr`)}</small>
                                <div className='d-inline-block'>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">    
                            <img src={Step02SVG} alt="Tutorial Step 01" />
                        </div>
                    </div>
                    :
                    <div className="row wrap_content">
                        <div className="col-md-6">
                                <div className="platform-step my-2">
                                    <div className='d-inline-block'>
                                        <span className="fs-7 fw-bold mb-1">{t(`${T_PREFIX}step2`)}</span>
                                        <h3 className='fs-6 fw-bold'>{t(`${T_PREFIX}code`)}</h3>
                                        {/* <p>{t(`${T_PREFIX}default.section.description`)}</p> */}
                                    </div>
                                </div>
                            <div className="platform-step mb-2">
                                <small className="fs-7">{t(`${T_PREFIX}code`)}</small>
                                <div className='d-inline-block'>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">    
                            <img src={Step03SVG} alt="Tutorial Step 01" />
                        </div>
                    </div>
                }
                <div className='nav_button'>
                    <button disabled={isStep1} onClick={()=> setIsStep1(true)}><Icon name='chevron_backward'></Icon></button>
                    <strong>{isStep1 ? 1 : 2}</strong>
                    <small>de 2</small>
                    <button disabled={!isStep1} onClick={()=> setIsStep1(false)}><Icon name='chevron_forward'></Icon></button>
                </div>
            </div>
        </div>
    );
};

export default (QrScan);